<template>
  <div class="container pb-5">
    <div class="row">
      <div class="col-12 px-0 px-md-3">
        <div class="card border-0">
          <div class="card-body">
            <div class="container pt-3 ">
              <header class="row mb-3 d-none d-lg-flex">
                <div class="col-8">
                  <h3 class="h4">
                    Take Attendance
                  </h3>
                </div>
                <div class="col-4 text-right">
                  <a href="#" class="btn btn-link text-body text-decoration-none p-0" @click.prevent="newEvent()">
                    <i class="fa fa-plus mr-1"></i>
                    New Event
                  </a>
                </div>
              </header>
              <div class="row">
                <div class="col-12">
                  <div class="alert alert-primary" v-if="!eventId">
                    Before taking attendance, please give your event a <b>title</b>
                    and pick your <b>event type</b>.
                  </div>

                  <div class="form-row mb-2">
                    <div class="col-12 col-lg-4 mb-3 mb-lg-0">
                      <input
                        type="text"
                        class="form-control input-lg"
                        placeholder="Event Title"
                        v-model="eventName"
                      >
                    </div>
                    <div class="col-12 col-lg-4 mb-3 mb-lg-0">
                      <select
                        class="custom-select"
                        v-model="eventType"
                      >
                        <option :value="null">Choose event type</option>
                        <option
                          v-for="(label, type) in eventTypes"
                          :value="type"
                        >
                          {{ label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-12 col-lg-4 mb-0">
                      <select
                        class="custom-select"
                        v-model="selectedOffice"
                      >
                        <option :value="null">All Offices</option>
                        <option
                          v-for="office in offices"
                          :value="office.id"
                        >
                          {{ office.display_name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <hr>

                  <ul class="nav nav-tabs mb-3">
                    <li class="nav-item">
                      <a href="#" @click.prevent="filter = 'all'" :class="{ 'nav-link': true, 'active': filter === 'all' }">
                        <i class="fa fa-bars"></i>
                        <span class="d-none d-md-inline ml-1">All</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#" @click.prevent="filter = 'attending'" :class="{ 'nav-link': true, 'active': filter === 'attending' }">
                        <i class="fa fa-check"></i>
                        <span class="d-none d-md-inline ml-1">Attending</span>
                      </a>
                    </li>
                    <!--

                    We decided to eliminate marking people absent

                    <li class="nav-item">
                        <a href="#" @click.prevent="filter = 'absent'" :class="{ 'nav-link': true, 'active': filter === 'absent' }">
                            <i class="fa fa-times mr-1"></i>
                            <span class="d-none d-md-inline ml-1">Absent</span>
                        </a>
                    </li>

                    -->
                    <li class="ml-auto">

                    </li>
                  </ul>

                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control input-lg"
                      placeholder="Search by name or email..."
                      v-model="query"
                    >
                    <small class="form-text text-muted ml-2">
                      or just scroll to find them
                    </small>
                  </div>

                  <p
                    v-if="loadingUsers"
                    class="text-muted"
                  >
                    <i class="fa fa-refresh fa-spin fa-fw"></i>
                    Loading users...
                  </p>

                  <div
                    v-for="user in orderedUsers"
                    v-if="!user.hide"
                    :id="`user_${user.id}`"
                    :class="{'card mb-1': true, 'disabled': !eventId, 'bg-flat-clouds': user.disabled }"
                  >
                    <div class="card-body p-3">
                      <div class="media">
                        <div class="media align-self-center mr-3">
                          <button
                            :disabled="!eventId"
                            style="width:42px;"
                            :class="{
                              'btn': true,
                              'btn-white': !user.status,
                              'btn-primary': user.status === 'attended',
                              'btn-danger': user.status === 'absent',
                            }"
                            @click.prevent="toggleStatus(user)"
                          >
                            <i class="fas fa-check-circle" v-if="user.status === 'attended'"></i>
                            <i class="fa fa-times" v-if="user.status === 'absent'"></i>
                            <i class="far fa-circle" v-if="!user.status"></i>
                          </button>
                        </div>
                        <div :class="{ 'media-body align-self-center': true }">
                          <div>
                            <a
                              :href="urls.people.show(user.id)"
                              target="_blank"
                            >
                              {{ user.name }}
                            </a>
                            <small class="text-muted">
                              {{ user.office_name }}
                            </small>
                          </div>
                          <div class="small text-muted">
                            {{ user.email }}
                          </div>
                        </div>
                        <div class="media-right  align-self-center">
                          <span
                            v-lazy:background-image="user.profile_photo_url"
                            class="agent-profile-img small"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div><!-- /.card -->

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alertify from 'alertify.js'
import _ from 'lodash'
import urls from '@/api/urls'
import elasticlunr from 'elasticlunr'
import { formatDate } from '@/lib/moment'
import { createBrowserHistory as createHistory } from 'history';
import { getAttendeeList, saveEvent, saveAttendeeStatus, removeAttendee } from '@/api'

export default {
  props: {
    event: {
      type: Object,
      default () {
        return {
          office_id: null,
        }
      }
    },
    eventTypes: {
      type: [Array, Object],
      required: true
    },
  },
  data () {
    return {
      urls,
      filter: 'all',
      query: '',
      loadingUsers: true,
      searchMatches: {},
      eventId: this.event.id,
      eventName: this.event.name || formatDate(new Date(), 'MMMM D'),
      eventType: this.event.type || null,
      userIndex: this.createIndex(),
      offices: [],
      selectedOffice: this.event.office_id || null,
      orderedUsers: [],
      userLookup: {},
      history: createHistory(),
      users: [],
    }
  },
  watch: {
    eventId () {
      this.history.replace(`/attendance${this.eventId ? '/' + this.eventId : ''}`, {
        eventId: this.eventId
      })
    },
    eventName () {
      if (this.eventId) {
        this.saveEvent()
      }
    },
    eventType () {
      this.saveEvent()
    },
    query () {
      this.search()
    },
    selectedOffice () {
      this.saveEvent()
    },
    searchMatches () {
      this.updateUsers()
    },
    filter () {
      this.updateUsers()
    }
  },
  mounted () {
    _.defer(() => this.loadAttendeeList())
  },
  methods: {
    createIndex () {
      return elasticlunr(function () {
        this.addField('name')
        this.addField('email')
        this.setRef('id')
      })
    },

    async loadAttendeeList () {
      this.loadingUsers = true
      let response = await getAttendeeList(this.eventId)

      this.userIndex = this.createIndex()
      this.userLookup = {}
      this.orderedUsers = []

      for (let i in response.data.users) {
        let user = response.data.users[i]
        user.hide = false
        this.userIndex.addDoc(user)
        this.orderedUsers.push(user)
        this.userLookup[parseInt(user.id)] = user
      }

      this.offices = response.data.offices
      this.updateUsers()
      this.loadingUsers = false
    },

    updateUsers () {
      for (let i in this.userLookup) {
        let user = this.userLookup[i]

        user.hide = null

        if (this.selectedOffice && (user.office_id !== this.selectedOffice && user.marketing_office_id !== this.selectedOffice)) {
          user.disabled = true
        } else if (user.challenging === false) {
          user.disabled = true
        } else {
          user.disabled = false
        }

        if (this.filter === 'attending' && user.status !== 'attended') {
          user.hide = true
        } else if (this.filter === 'absent' && user.status !== 'absent') {
          user.hide = true
        }

        if (this.query.length > 0) {
          if (user.hide === null) {
            user.hide = !this.searchMatches[user.id]
          }
        }
      }

      _.defer(() => this.updateUserOrder())
    },

    updateUserOrder () {
      this.orderedUsers = _.sortBy(this.orderedUsers, (user) => {
        return user.disabled ? 2 : 1
      });
    },

    newEvent () {
      alertify.confirm('Are you sure you want to create a new event?', () => {
        document.location = '/attendance'
      })
    },

    async toggleStatus (user) {
      if (!this.eventId) {
        return false
      }

      /*
      We decided to eliminate marking people absent

      if (!user.status) {
        user.status = 'attended'
      } else if (user.status === 'attended') {
        user.status = 'absent'
      } else if (user.status === 'absent') {
        user.status = null
      }
      */

      if (!user.status) {
        user.status = 'attended'
      } else {
        user.status = null
      }

      if (user.status) {
        try {
          await saveAttendeeStatus(this.eventId, user.id, user.status)
          alertify.log('Saved.')
        } catch (e) {
          alertify.error('Oops! Something went wrong')
        }
      } else {
        try {
          await removeAttendee(this.eventId, user.id)
          alertify.log('Saved.')
        } catch (e) {
          alertify.error('Oops! Something went wrong')
        }
      }
    },

    saveEvent: _.debounce(function () {
      saveEvent(this.eventId, {
        name: this.eventName,
        type: this.eventType,
        office_id: this.selectedOffice
      }).then((response) => {
        alertify.log('Event details saved.')
        this.eventId = response.data.id
        this.loadAttendeeList()
      }).catch((e) => {
        // TODO: handle error
      })
    }, 300),

    search: _.debounce(function (e) {
      let searchMatches = {}

      let found = this.userIndex.search(this.query, {
        expand: true
      })

      for (let f in found) {
        searchMatches[parseInt(found[f].ref)] = true
      }

      this.searchMatches = searchMatches
    }, 100)
  }
}
</script>